import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, Accordion, TextInput, Button, ActionIcon } from '@mantine/core';
import { useResizeObserver } from '@mantine/hooks';
import SignatureCanvas from 'react-signature-canvas';
import { IconPencil } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_ONE, utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { dataURLtoFile } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const CustomerSignature = ({ stateData, fnSuccessChange, fnSuccessChangeName }) => {

  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();
  const signatureCanvasRef = React.useRef(null);
  const [refDrawer, rectDrawer] = useResizeObserver();

  const notificationId = React.useRef({
    errorSubmitData: 'CustomerSignature-1',
    errorDeleteData: 'CustomerSignature-2',
    errorSubmitDataName: 'CustomerSignature-3',
  })

  const [data, setData] = React.useState({
    submitLoading: false,
    fileUploadingProgress: 0,

    ubahShow: false,

    hapusShow: false,
    hapusLoading: false,

    ubahNamaShow: false,
    ubahNamaValue: '',
    ubahNamaValueError: '',
    ubahNamaLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
  };

  const checkIfEmpty = () => {
    const isEmpty = signatureCanvasRef.current.isEmpty();
    return isEmpty;
  };

  const saveSignature = () => {
    if (checkIfEmpty()) {
      setData(d => ({
        ...d,
        modalResponse: {
          ...d.modalResponse,
          type: utils.modalResponse.warning,
          hideOnClickOutSide: true,
          content: 'Ooppss.. Belum ada tanda tangan untuk disimpan.',
          show: true
        }
      }))
    } else {
      // info : tidak di trim
      // const signatureImage = signatureCanvasRef.current.toDataURL();

      // info : with trim
      const signatureImage = signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png');
      const resFile = dataURLtoFile({ stateDataUrl: signatureImage, stateFileName: 'signature.png' });

      setData(d => ({ ...d, submitLoading: true, }));

      const formDT = new FormData();
      const formDTHeader = { Accept: 'application/json', 'Content-Type': 'multipart/form-data' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('customer_id', stateData.customerId);

      formDT.append('photos[0]', resFile);
      formDT.append('image_max_size_in_mb', utils.imageMaxSizeUploadFotoInMB);

      axios({
        method: 'post',
        url: BE_API_ONE + '/customer_signature_add',
        data: formDT,
        headers: formDTHeader,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          setData(d => ({ ...d, fileUploadingProgress: percentCompleted }))
        }
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false, fileUploadingProgress: 0 }));

        if (response.data.flag_status === 'isset') {
          // fnOnAdded(response.data.data);
          clearSignature();
          fnSuccessChange(Array.isArray(response.data.data) && (response.data.data.length > 0) ? response.data.data[0]['customer_signature'] : null);
          setData(d => ({ ...d, ubahShow: false }))
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'error') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Error : ' + response.data.pesan,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'wrong-type') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `"${response.data.suspect}" tidak sesuai dengan format yang diizinkan (${response.data.allowed}).`,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'wrong-size') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: `"${response.data.suspect}" melebihi ukuran yang diizinkan (${response.data.max_size}).`,
              show: true
            }
          }))
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, submitLoading: false }))

        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  };

  // const saveSignatureData = () => {
  //     const data = signatureCanvasRef.current.toData();
  //     // Save the data array for later use
  // };

  const deleteSign = () => {
    setData(d => ({ ...d, hapusLoading: true, }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('customer_id', stateData.customerId);

    axios({
      method: 'post',
      url: BE_API_ONE + '/customer_signature_delete',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, hapusLoading: false, hapusShow: false }));

      if (response.data.flag_status === 'isset') {
        // fnOnAdded(response.data.data);
        // clearSignature(); 
        fnSuccessChange(Array.isArray(response.data.data) && (response.data.data.length > 0) ? response.data.data[0]['customer_signature'] : null);
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'error') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Error : ' + response.data.pesan,
            show: true
          }
        }))
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, hapusLoading: false, hapusShow: false }))

      notifications.show({
        id: notificationId.current.errorDeleteData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const ubahNama = () => {
    setData(d => ({ ...d, ubahNamaValueError: '' }));

    if (validator.isEmpty(data.ubahNamaValue, { ignore_whitespace: true })) {
      setData(d => ({ ...d, ubahNamaValueError: 'Isi nama customer.' }));
    } else {
      setData(d => ({ ...d, ubahNamaLoading: true }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('customer_id', stateData.customerId);
      formDT.append('sign_name', data.ubahNamaValue);

      axios({
        method: 'post',
        url: BE_API_ONE + '/customer_signature_name_edit',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, ubahNamaLoading: false, ubahNamaShow: false }));

        if (response.data.flag_status === 'isset') {
          fnSuccessChangeName(Array.isArray(response.data.data) && (response.data.data.length > 0) ? response.data.data[0]['customer_signature_name'] : '');
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmitDataName,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, ubahNamaLoading: false, ubahNamaShow: false }))

        notifications.show({
          id: notificationId.current.errorSubmitDataName,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>
      <Accordion
        mt='md'
        variant='contained'
        chevronPosition="left"
      >
        <Accordion.Item value="signCust">
          <Accordion.Control>Tanda Tangan Digital</Accordion.Control>
          <Accordion.Panel>
            {stateData.projectCustomerSign && !data.ubahShow &&
              <Box>
                <Group
                  position='center'
                >
                  <img
                    alt='signature'
                    src={ROOT_BASE_URL + '' + stateData.projectCustomerSign}
                    style={{
                      width: 'auto',
                      maxWidth: '100%',
                      backgroundColor: '#fff'
                    }}
                  />
                </Group>

                <Group
                  mt='lg'
                  position='center'
                  align='flex-start'
                  spacing='xs'
                  noWrap
                >
                  <Text
                    size='sm'
                    color={stateData.projectCustomerSignName ? '' : 'dimmed'}
                  >
                    {stateData.projectCustomerSignName ? stateData.projectCustomerSignName : 'Nama Customer..'}
                  </Text>

                  <ActionIcon
                    size='sm'
                    variant='light'
                    radius='xl'

                    onClick={() => setData(d => ({
                      ...d,
                      ubahNamaValue: stateData.projectCustomerSignName,
                      ubahNamaShow: true
                    }))}
                  >
                    <IconPencil
                      size='1rem'
                      stroke={1}
                    />
                  </ActionIcon>
                </Group>

                <Group
                  mt='lg'
                  position='center'
                >
                  <Button
                    size="xs"
                    color="red"
                    onClick={() => setData(d => ({ ...d, hapusShow: true }))}
                    loading={data.hapusLoading}
                  >
                    Hapus TTD
                  </Button>

                  <Button
                    size="xs"
                    onClick={() => setData(d => ({ ...d, ubahShow: true }))}
                    loading={data.ubahNamaLoading}
                  >
                    Ubah TTD
                  </Button>
                </Group>
              </Box>
            }

            <Box
              ref={refDrawer}
            >
              {(!stateData.projectCustomerSign || data.ubahShow) &&
                <Box>
                  <Box>
                    {!stateData.projectCustomerSign &&
                      <Text
                        color="dimmed"
                        size='sm'
                        mb='sm'
                      >
                        Silahkan buat tanda tangan digital pada kotak berwarna putih ini.
                      </Text>
                    }

                    <Box
                      sx={(tema) => ({
                        backgroundColor: '#fff',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderColor: tema.colorScheme === 'light' ? tema.colors.gray[6] : tema.colors.dark[6]
                      })}
                    >
                      <SignatureCanvas
                        ref={signatureCanvasRef}
                        penColor='black'

                        canvasProps={{
                          width: rectDrawer.width,
                          height: rectDrawer.width,
                        }}
                      />
                    </Box>
                  </Box>

                  <Group
                    mt='lg'
                    position='center'
                    align='flex-start'
                    spacing='xs'
                    noWrap
                  >
                    <Text
                      size='sm'
                      color={stateData.projectCustomerSignName ? '' : 'dimmed'}
                    >
                      {stateData.projectCustomerSignName ? stateData.projectCustomerSignName : 'Nama Customer..'}
                    </Text>

                    <ActionIcon
                      size='sm'
                      variant='light'
                      radius='xl'

                      onClick={() => setData(d => ({
                        ...d,
                        ubahNamaValue: stateData.projectCustomerSignName,
                        ubahNamaShow: true
                      }))}
                    >
                      <IconPencil
                        size='1rem'
                        stroke={1}
                      />
                    </ActionIcon>
                  </Group>

                  <Group
                    mt='lg'
                    position='center'
                  >
                    <Group>
                      <Button
                        size="xs"
                        onClick={clearSignature}
                        variant="light"
                      >
                        Clear
                      </Button>

                      <Button
                        size="xs"
                        onClick={saveSignature}
                        loading={data.submitLoading}
                      >
                        Save
                      </Button>
                    </Group>

                    {stateData.projectCustomerSign &&
                      <Button
                        size="xs"
                        variant="light"
                        color="red"
                        onClick={() => setData(d => ({ ...d, ubahShow: false }))}

                        sx={{
                          marginLeft: 'auto'
                        }}
                      >
                        Batal
                      </Button>
                    }
                  </Group>
                </Box>
              }
            </Box>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateOverlayZIndex={201}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.hapusShow}
        fnHide={() => setData(d => ({ ...d, hapusShow: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Ya, Hapus'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.hapusLoading}
        fnButtonAction={deleteSign}
      >
        <Text
          size='sm'
          color="dimmed"
          mb='md'
        >
          Hapus Tanda Tangan Ini ?
        </Text>
      </ModalTakeAction>

      <ModalTakeAction
        stateShow={data.ubahNamaShow}
        fnHide={() => setData(d => ({ ...d, ubahNamaShow: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Nama Customer').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.ubahNamaLoading}
        fnButtonAction={ubahNama}
      >
        <TextInput
          label='Nama Customer'
          placeholder="Nama Customer"
          description='Nama ini akan digunakan untuk nama pada tanda tangan. Tidak akan mengubah nama utama.'
          value={data.ubahNamaValue}
          onChange={(e) => setData(d => ({ ...d, ubahNamaValue: e.target.value }))}
          withAsterisk
          error={data.ubahNamaValueError}
        />
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default CustomerSignature;